import { createStore, combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import authReducer from './reducers/auth';
import siteReducer from './reducers/site';

const persistConfig = {
  key: 'Alice-Portal',
  storage,
  whitelist: ['authentication'],
};

const authPersistConfig = {
  key: 'authentication',
  storage,
  whitelist: ['user']
};

const sitePersistConfig = {
  key: 'site',
  storage,
  blacklist: ['tempCurrency', 'message']
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  site: persistReducer(sitePersistConfig, siteReducer)
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// export const store = createStore(rootReducer);
export const store = createStore(persistedReducer);
export const persistor = persistStore(store);
